import { HTTPINPUTTYPE } from '../../../../../../../enums/HTTPINPUTTYPE.js';
import INPUT from '../../../../../../DOM/form/fieldset/field/input/INPUT.js';
import { makeStruct } from '../../../../../../../enums/MODELS.js';
import { makeAttrStruct } from '../../../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../../../enums/ModelData.js';
// Model Structure
export const inputTextAttr = makeAttrStruct([
    ['name'],
    ['class'],
    ['value'],
    ['placeholder'],
    ['required', false],
    ['type', HTTPINPUTTYPE.TEXT]
]);
export const inputTextData = makeDataStruct([]);
export const inputTextModel = makeStruct([
    ['attributes', inputTextAttr],
    ['data', inputTextData]
]);
// Simplified Model
export function inputText(name, className, value, placeholder, required) {
    return {
        attributes: inputTextAttr(name, className, value, placeholder, required),
        data: inputTextData()
    };
}
// Class
export default class INPUTTEXT extends INPUT {
    constructor(node, model) {
        super(node, model);
    }
}
